// Kopfzeile der Unterseiten (Statistik, Leaderboard, Einstellungen, Karte):
// Pfeil zurueck zum Hauptscreen plus Titel, wie in den Referenz-Screenshots.
// Der Hauptscreen selbst hat eine andere Kopfzeile (Drawer statt Pfeil),
// siehe Hauptscreen.tsx.

import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function Unterseite({
  titel,
  kinder,
  zurueckZu = "/",
  unterKopf,
  inhaltKlasse = "mx-auto max-w-md p-4",
}: {
  titel: string;
  kinder: ReactNode;
  /** Wohin der Pfeil fuehrt. Eine Unterseite zweiter Ebene geht auf ihre Liste zurueck, nicht auf den Hauptscreen. */
  zurueckZu?: string;
  /** Faellt in die blaue Kopfleiste, unter den Titel (Reiter der Statistik-Unterseiten). */
  unterKopf?: ReactNode;
  /** Fuer Listen, die im Original fast randlos stehen. */
  inhaltKlasse?: string;
}) {
  const navigate = useNavigate();
  return (
    <div className="min-h-full bg-flaeche-grund font-sans text-neutral-900">
      <header className="bg-akzent text-white shadow">
        <div className="flex items-center gap-4 px-2 py-3">
          <button
            type="button"
            onClick={() => navigate(zurueckZu)}
            aria-label="Zurück"
            className="flex min-h-11 min-w-11 items-center justify-center"
          >
            <ChevronLeft size={26} />
          </button>
          <h1 className="text-lg font-medium">{titel}</h1>
        </div>
        {unterKopf}
      </header>
      <main className={inhaltKlasse}>{kinder}</main>
    </div>
  );
}
